import { gql } from '@apollo/client';
import type { SearchFragment } from '../../../../../types';

export const SEARCH_FRAGMENT_QUERY = gql`
  query fragment($galleryId: ID!, $pageNumber: Int!, $tag: String!) {
    fragment(galleryId: $galleryId, pageNumber: $pageNumber, tag: $tag)
      @rest(
        type: "SearchFragment"
        method: "GET"
        path: "/galleries/api/galleries/{args.galleryId}/photos/_paginatedSearch?pageNumber={args.pageNumber}&tags={args.tag}"
        endpoint: "bff"
      ) {
      id
      hasMorePages
      pageNumber
      tag
      total
      type
      photos {
        id
        fileName
        tags
        status
        thumbnailFile {
          type
          uri
        }
        processedFile {
          type
          uri
        }
      }
    }
  }
`;

export type SearchFragmentQueryVariables = {
  galleryId: string;
  pageNumber: number;
  tag: string;
};

export type SearchFragmentResponseData = {
  fragment: SearchFragment;
};
